import { Component, OnInit } from '@angular/core';
import {AngularFireDatabase, AngularFireList} from '@angular/fire/database';
import {Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import {PredictedSignal} from '../predicted-signal.model';
@Component({
  selector: 'app-view-pulsar-signals',
  templateUrl: './view-pulsar-signals.component.html',
  styleUrls: ['./view-pulsar-signals.component.scss']
})
export class ViewPulsarSignalsComponent implements OnInit {
  headElements = ['Mean of the Integrated Profile', 'Standard Deviation of the Integrated Profile',
    'Excess Kurtosis of the Integrated Profile', 'Skewness of the Integrated Profile', 'Mean of the DM-SNR Curve',
    'Standard Deviation of the DM-SNR Curve', 'Excess Kurtosis of the DM-SNR Curve', 'Skewness of the DM-SNR Curve'];
  itemsRef: AngularFireList<any>;
  items: Observable<PredictedSignal[]>;
  constructor(private db: AngularFireDatabase) {
  }

  ngOnInit(): void {
    this.itemsRef = this.db.list('asips-3efdd-default-rtdb/Confirmed');
    // Use snapshotChanges().map() to store the key
    this.items = this.itemsRef.snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
      )
    );

  }


}

